import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Modal, getTranslation } from '@resy/ui-kitchen';

import TockInterstitial from './TockInterstitial';
import { closeTockInterstitial } from '../../../../../ui-kitchen/src/reducers/tockInterstitialSlice';

const modalStyles = {
  overlay: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    zIndex: '8',
  },
  content: {
    background: '#fff',
    border: '1px solid #cacaca',
    borderRadius: '12px',
    height: 'auto',
    width: '404px',
    left: 'auto',
    right: 'auto',
    top: 'auto',
    bottom: 'auto',
    position: 'relative',
    padding: 0,
    zIndex: '8',
  },
};

const TockInterstitialModal = ({
  Analytics,
  isOpen,
  pendingUrl,
  closeInterstitial,
}) => {
  const trackDismiss = (method) => {
    Analytics.event('dismiss modal', { destination: 'tock redirect', method });
  };

  const handleCloseButtonClose = () => {
    trackDismiss('close button');
    closeInterstitial();
  };

  const handleRequestClose = (event) => {
    if (event && event.type === 'click') {
      trackDismiss('background');
    } else if (event && event.type === 'keydown' && (event.key === 'Escape' || event.code === 'Escape')) {
      trackDismiss('esc key');
    }
    closeInterstitial();
  };

  const handleConfirm = () => {
    Analytics.event('click modal', { destination: 'tock redirect' });
    if (pendingUrl) {
      window.open(pendingUrl, '_blank', 'noopener');
    }
    closeInterstitial();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      contentLabel={getTranslation({
        translationKey: 'tock_interstitial_content_label',
        fallback: 'Tock booking interstitial',
      })}
      styles={modalStyles}
      shouldCloseOnOverlayClick
      className="TockInterstitialModal"
    >
      <TockInterstitial Analytics={Analytics} onConfirm={handleConfirm} onClose={handleCloseButtonClose} />
    </Modal>
  );
};

TockInterstitialModal.displayName = 'TockInterstitialModal';

TockInterstitialModal.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  pendingUrl: PropTypes.string,
  closeInterstitial: PropTypes.func.isRequired,
};

TockInterstitialModal.defaultProps = {
  pendingUrl: null,
};

const mapStateToProps = (state) => {
  const slice = state.tockInterstitial;
  return {
    isOpen: !!(slice && slice.isOpen),
    pendingUrl: (slice && slice.pendingUrl) || null,
  };
};

const mapDispatchToProps = {
  closeInterstitial: closeTockInterstitial,
};

export { TockInterstitialModal };
export default connect(mapStateToProps, mapDispatchToProps)(TockInterstitialModal);
